import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";

import element from "./components/element-index";
import "@/style/main.scss";
import '@/style/element-variables.scss'

Vue.config.productionTip = false
Vue.prototype.$http = axios;

Vue.use(element);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
